/* src/app/modules/resume/resume.component.css */
.container {
  width: 100%;
}
.rp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 24px 24px 0;
}
.rp-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.rp-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, .12);
  flex-shrink: 0;
}
.rp-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.rp-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a1d23;
}
.rp-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
}
@media only screen and (max-width: 600px) {
  .rp-header {
    justify-content: flex-start;
  }
}
::ng-deep .mat-mdc-tab-body-content {
  padding: 24px;
  box-sizing: border-box;
}
::ng-deep .mat-mdc-tab-header {
  border-bottom: none;
}
::ng-deep .mat-mdc-tab {
  height: 48px;
  background-color: transparent !important;
  opacity: .6;
}
::ng-deep mat-tab-group.mt-3 .mat-mdc-tab.mdc-tab--active {
  background: transparent !important;
}
::ng-deep .mat-mdc-tab:hover,
::ng-deep .mat-mdc-tab.mdc-tab--active {
  opacity: 1;
}
::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: normal;
}
::ng-deep .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 400;
}
::ng-deep .mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #e3fd64 !important;
  border-top-width: 3px !important;
}
::ng-deep .mat-mdc-tab:not(.mdc-tab--active) .mdc-tab-indicator__content--underline {
  opacity: 0;
}
::ng-deep .mat-mdc-tab:hover:not(.mdc-tab--active) .mdc-tab-indicator__content--underline {
  opacity: 1;
}
::ng-deep .mat-mdc-tab .mdc-tab-indicator {
  transition: opacity 0.15s ease;
}
.row {
  border: 1px solid #e0e0e0;
  width: 90%;
  margin: auto;
  margin-bottom: 1%;
  background-color: white;
  border-radius: 10px;
}
.row .graph_canvas {
  padding: 5%;
  width: 50%;
  margin: auto;
  float: left;
}
.row .graph_text {
  width: 50%;
  padding-top: 10px;
  text-align: left;
  margin: auto;
  float: left;
}
.mat-mdc-dialog-container {
  max-height: 70vh !important;
}
.m-10 {
  margin: 1%;
}
@media only screen and (max-width: 700px) {
  .row .graph_canvas {
    width: 80%;
  }
  .row .graph_text {
    width: 80%;
  }
  .mat-mdc-tab-group {
    display: grid;
  }
}
@media only screen and (max-width: 450px) {
  .row .graph_canvas {
    width: 100%;
  }
  .row .graph_text {
    width: 100%;
  }
  .mat-mdc-tab-group {
    display: grid;
  }
}
.tabla-resultados {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9em;
}
.tabla-resultados th {
  background-color: #e3fd64;
  color: #1a1d23;
  padding: 5px;
}
.tabla-resultados td {
  border: 1px solid #ddd;
  padding: 5px;
}
.tabla-resultados tr:nth-child(even) {
  background-color: #f2f2f2;
}
.rd-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 56px 24px;
}
.rd-loading__dots {
  display: flex;
  gap: 8px;
}
.rd-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.3;
  animation: rd-pulse 1.2s ease-in-out infinite;
}
.rd-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.rd-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.rd-loading__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
@keyframes rd-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.rd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
  gap: 12px;
}
.rd-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.rd-header__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  flex-shrink: 0;
}
.rd-header__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.rd-icon--green {
  background: rgba(22, 163, 74, 0.1);
}
.rd-icon--green mat-icon {
  color: #16a34a;
}
.rd-icon--orange {
  background: rgba(227, 253, 100, 0.1);
}
.rd-icon--orange mat-icon {
  color: #d97706;
}
.rd-icon--red {
  background: rgba(220, 38, 38, 0.1);
}
.rd-icon--red mat-icon {
  color: #dc2626;
}
.rd-header__title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 17px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
  color: #1a1d23;
}
.rd-header__sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.rd-header__actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.rd-export-btn {
  color: #6b7280 !important;
}
.rd-export-btn:hover {
  color: #e3fd64 !important;
  background: rgba(227, 253, 100, 0.08) !important;
}
.rd-close-btn {
  color: #9ca3af !important;
}
.rd-subnav {
  display: flex;
  gap: 6px;
  padding: 12px 24px 0;
  flex-wrap: wrap;
}
.rd-subnav__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1.5px solid #e5e7eb;
  background: #f9fafb;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}
.rd-subnav__btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.rd-subnav__btn:hover {
  border-color: #e3fd64;
  color: #d97706;
  background: rgba(227, 253, 100, 0.06);
}
.rd-subnav__btn.active {
  border-color: #e3fd64;
  background: rgba(227, 253, 100, 0.1);
  color: #92400e;
  font-weight: 600;
}
.rd-content {
  padding: 16px 24px 24px !important;
  max-height: 60vh;
}
.rs-stat-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
  padding-bottom: 16px;
}
.rs-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1.5px solid transparent;
  background: #f9fafb;
  cursor: default;
  text-align: left;
  font-family: inherit;
  width: 170px;
  transition: transform 0.15s, box-shadow 0.15s;
}
button.rs-stat {
  cursor: pointer;
}
button.rs-stat:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.rs-stat--green {
  background: rgba(22, 163, 74, 0.06);
  border-color: rgba(22, 163, 74, 0.2);
}
.rs-stat--green .rs-stat__label {
  color: #15803d;
}
.rs-stat--green .rs-stat__value {
  color: #16a34a;
}
.rs-stat--orange {
  background: rgba(227, 253, 100, 0.06);
  border-color: rgba(227, 253, 100, 0.25);
}
.rs-stat--orange .rs-stat__label {
  color: #b45309;
}
.rs-stat--orange .rs-stat__value {
  color: #d97706;
}
.rs-stat--red {
  background: rgba(220, 38, 38, 0.06);
  border-color: rgba(220, 38, 38, 0.2);
}
.rs-stat--red .rs-stat__label {
  color: #b91c1c;
}
.rs-stat--red .rs-stat__value {
  color: #dc2626;
}
.rs-stat--total {
  background: #f3f4f6;
  border-color: #e5e7eb;
  cursor: default;
}
.rs-stat--total .rs-stat__label {
  color: #6b7280;
}
.rs-stat--total .rs-stat__value {
  color: #1a1d23;
}
.rs-stat__label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.rs-stat__label mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.rs-stat__value {
  font-size: 18px;
  font-family:
    "Bricolage Grotesque",
    "Inter Tight",
    sans-serif;
  font-weight: 700;
  line-height: 1.2;
}
.rs-stat__hint {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
}
/*# sourceMappingURL=resume.component.css.map */
